<template>
  <div v-if="!loading">
    <Menu />
    <header class="site-nav">
      <div class="container">
        <div class="site-nav-inner d-flex align-items-center justify-content-between">

          <div class="brand-lockup">
            <a href="/home" class="d-flex align-items-center text-decoration-none">
              <img src="https://www.stratitude.co.za/chas-international/dubai/images/chas-logo.svg" alt="Chas Everitt" class="brand-logo" loading="lazy" />
            </a>

            <span class="brand-divider d-none d-md-inline-block" aria-hidden="true"></span>

            <div class="d-none d-md-block">
              <a href="https://www.leadingre.com/" class="d-flex align-items-center text-decoration-none" target="_blank" rel="noopener noreferrer">
                <img src="https://www.stratitude.co.za/chas-international/dubai/images/leading-logo1.png" alt="Leading Real Estate" class="partner-logo" loading="lazy" />
              </a>
            </div>
          </div>

          <nav class="d-none d-lg-flex site-nav-links align-items-center">
            <a class="nav-link" href="/properties">Buy</a>
            <a class="nav-link" href="/sell">Sell</a>
            <a class="nav-link" href="/developments" aria-current="page">Developments</a>
            <a class="nav-link" href="/commercial" aria-current="page">Commercial</a>
          </nav>

          <button class="btn hamburger d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileNav" aria-label="Open menu">
            <i class="bi bi-list" style="font-size:1.25rem;"></i>
          </button>

        </div>
      </div>
    </header>

    <section v-if="!loading && canDisplayProperty">

      <section class="hero-com d-flex align-items-end" v-if="!loading && ogListing[0]">

        <!-- dynamic listing hero image -->
        <img v-if="ogListing[0].listing_images && ogListing[0].listing_images[0]" :src="ogListing[0].listing_images[0]" class="hero-image" alt="Property hero" style="cursor:pointer;" data-bs-toggle="modal" data-bs-target="#galleryModal" @click="openGalleryFromListing()" />

        <div class="container pb-4 hero-content">
          <div class="property-kicker">
            For Sale
          </div>

          <h1 class="property-title mt-2" style="text-transform: uppercase;">
            <strong>{{ ogListing[0].marketing_heading }}</strong>
          </h1>


          <div class="property-sub">
            R {{ formattedPrice }} • {{ ogListing[0].loc_suburb }}, {{ ogListing[0].loc_region }}
          </div>
        </div>

      </section>


      <section class="property-summary" v-if="ogListing[0]">
        <div class="container">
          <div class="d-flex flex-wrap align-items-center gap-2 justify-content-center justify-content-md-between">

            <!-- Left: chips -->
            <div class="d-flex flex-wrap gap-2 justify-content-center justify-content-md-start">

              <div class="summary-chip" v-if="ogListing[0].bedrooms !== 0">
                Beds <strong>{{ ogListing[0].bedrooms }}</strong>
              </div>

              <div class="summary-chip" v-if="ogListing[0].bathrooms !== 0">
                Baths <strong>{{ ogListing[0].bathrooms }}</strong>
              </div>

              <div class="summary-chip" v-if="ogListing[0].lounges !== 0">
                Lounges <strong>{{ ogListing[0].lounges }}</strong>
              </div>

              <div class="summary-chip" v-if="ogListing[0].parking && ogListing[0].parking !== 0">
                Parking <strong>{{ ogListing[0].parking }}</strong>
              </div>

              <div class="summary-chip" v-if="ogListing[0].building_size !== 0">
                Size <strong>{{ ogListing[0].building_size }} m²</strong>
              </div>

              <div class="summary-chip" v-if="ogListing[0].land_size !== 0">
                Land <strong>{{ ogListing[0].land_size }} m²</strong>
              </div>

            </div>

            <!-- Right: View Gallery button -->
            <div class="ms-md-auto">
              <button type="button" class="btn btn-gallery" data-bs-toggle="modal" data-bs-target="#galleryModal" @click="openGalleryFromListing()">
                View Gallery
              </button>
            </div>

          </div>
        </div>
      </section>

      <!-- GALLERY MODAL -->
      <div class="modal fade" id="galleryModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered">
          <div class="modal-content gallery-modal">

            <div class="modal-header">
              <h5 class="modal-title">Gallery</h5>

              <!-- Toggle inside modal header (same structure as original) -->
              <div class="btn-group ms-auto me-2" role="group" aria-label="Gallery view toggle">
                <button type="button" class="btn btn-outline-secondary btn-sm" id="btnSingle" :class="{ active: galleryView === 'single' }" @click="showSingle()">
                  Single
                </button>

                <button type="button" class="btn btn-outline-secondary btn-sm" id="btnGrid" :class="{ active: galleryView === 'grid' }" @click="showGrid()">
                  Grid
                </button>
              </div>

              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">

              <!-- SINGLE VIEW (same id as original) -->
              <div id="gallerySingleView" :class="{ 'd-none': galleryView !== 'single' }">
                <div id="galleryCarousel" class="carousel slide" data-bs-ride="false">
                  <div class="carousel-inner">

                    <div class="carousel-item" v-for="(img, idx) in galleryImages" :key="'slide-' + idx" :class="{ active: idx === 0 }">
                      <img :src="img" class="d-block w-100 gallery-img" :alt="'Property image ' + (idx + 1)">
                    </div>

                  </div>

                  <button class="carousel-control-prev" type="button" data-bs-target="#galleryCarousel" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>

                  <button class="carousel-control-next" type="button" data-bs-target="#galleryCarousel" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>

              <!-- GRID VIEW (same id + d-none behaviour as original) -->
              <div id="galleryGridView" :class="{ 'd-none': galleryView !== 'grid' }">
                <div class="row g-3">

                  <!-- Clicking a tile switches to single view + jumps to that slide -->
                  <div class="col-6 col-md-4" v-for="(img, idx) in galleryImages" :key="'thumb-' + idx">
                    <button class="thumb-btn" type="button" :data-index="idx" @click="thumbClick(idx)">
                      <img class="thumb-img gallery-zoom" :src="img" :alt="'Thumbnail ' + (idx + 1)">
                    </button>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <section class="py-5 bg-white" v-if="!loading && ogListing[0]">
        <div class="container">
          <div class="row g-4">

            <!-- LEFT COLUMN -->
            <div class="col-12 col-lg-8">

              <div class="section-title">About Property</div>
              <div class="section-rule"></div>

              <!-- description from API -->
              <p class="paragraph" v-html="ogListing[0].description"></p>

              <div class="row g-3 mt-3">
                <div class="col-12 col-md-6">
                  <div class="property-box">
                    <div class="ref-label">Property Type</div>
                    <p class="mb-0 fw-bold">
                      {{ ogListing[0].property_type || ogListing[0].listing_type || '—' }}
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="property-box">
                    <div class="ref-label">Status</div>
                    <p class="mb-0 fw-bold">
                      {{ ogListing[0].status || '—' }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="regulatory-panel mt-5">
                <div class="row g-4 align-items-start">
                  <div class="col-12 col-xl-4">
                    <h3 class="regulatory-title">Property details</h3>

                    <div class="reg-row">
                      <strong>Property Type</strong>
                      <span>{{ ogListing[0].property_type || ogListing[0].listing_type || '—' }}</span>
                    </div>

                    <div class="reg-row" v-if="showNumber(ogListing[0].building_size)">
                      <strong>Property Size</strong>
                      <span>{{ formatSize(ogListing[0].building_size, ogListing[0].building_measurement_type) }}</span>
                    </div>

                    <div class="reg-row" v-if="showNumber(ogListing[0].land_size)">
                      <strong>Land Size</strong>
                      <span>{{ formatSize(ogListing[0].land_size, ogListing[0].land_measurement_type) }}</span>
                    </div>

                    <div class="reg-row" v-if="ogListing[0].occupation_date">
                      <strong>Available from</strong>
                      <span>{{ formatDate(ogListing[0].occupation_date) }}</span>
                    </div>
                  </div>

                  <div class="col-12 col-xl-5">
                    <h3 class="regulatory-title">Regulatory information</h3>

                    <div class="reg-row">
                      <strong>Reference</strong>
                      <span>{{ ogListing[0].web_ref || ogListing[0].own_ref_number || ogListing[0].listing_number || ogListing[0].reference || ogListing[0].id || '—' }}</span>
                    </div>

                    <div class="reg-row">
                      <strong>Listed</strong>
                      <span>{{ listedAgo }}</span>
                    </div>

                    <div class="reg-row">
                      <strong>Broker License</strong>
                      <span>{{ brokerLicense }}</span>
                    </div>

                    <div class="reg-row">
                      <strong>Agency name</strong>
                      <span>Chas Everitt International</span>
                    </div>

                    <div class="reg-row">
                      <strong>Zone name</strong>
                      <span>{{ ogListing[0].loc_region || ogListing[0].loc_suburb || 'Dubai' }}</span>
                    </div>

                    <div class="reg-row">
                      <strong>Agent License</strong>
                      <span>{{ agentLicense }}</span>
                    </div>
                  </div>

                  <div class="col-12 col-xl-3 text-center">
                    <img
                      v-if="dldQrCode"
                      :src="dldQrCode"
                      class="dld-qr"
                      alt="DLD QR Code"
                    />

                    <div class="dld-label mt-3">DLD Permit Number</div>

                    <img
                      v-if="dldPermitImage"
                      :src="dldPermitImage"
                      class="dld-permit-image"
                      alt="DLD Permit Number"
                    />
                  </div>
                </div>
              </div>

              <!-- VIDEO (same as old, but in new layout) -->
              <div class="mt-5" v-if="ogListing[0].video_id !== null">
                <div class="section-title">Video</div>
                <div class="section-rule"></div>

                <div class="property-box p-2">
                  <div class="ratio ratio-16x9">
                    <iframe :src="'https://www.youtube.com/embed/' + ogListing[0].video_id + '?rel=0&modestbranding=1'" title="Property video" allowfullscreen></iframe>
                  </div>
                </div>
              </div>

            </div>

            <!-- RIGHT COLUMN -->
            <div class="col-12 col-lg-4">

              <div class="property-box">
                <div class="ref-label">Price</div>
                <p class="property-price">R {{ formattedPrice }}</p>

                <div class="ref-label">Reference</div>
                <p class="mb-0 fw-bold">
                  {{ ogListing[0].listing_number || ogListing[0].reference || '—' }}
                </p>

                <div class="d-grid gap-2 mt-3">
                  <a href="#agent" class="btn btn-all">Contact Agent</a>

                  <!-- wire this later if you have a brochure URL -->
                  <a href="#" class="btn btn-outline-brand">Download Brochure</a>
                </div>
              </div>

              <!-- AGENT DETAILS (uses your existing toggles + links) -->
              <div id="agent" class="agent-card mt-4" v-if="agent && agent.first_name">
                <div class="section-title">Agent Details</div>
                <div class="section-rule"></div>

                <div class="d-flex gap-3 align-items-center">
                  <div class="agent-photo" v-if="agent.agent_photo">
                    <img :src="agent.agent_photo" :alt="agent.first_name + ' ' + agent.last_name">
                  </div>
                  <div>
                    <p class="agent-name">{{ agent.first_name }} {{ agent.last_name }}</p>
                    <p class="agent-role">{{ agent.position || agent.role || '' }}</p>
                  </div>
                </div>

                <div class="agent-links d-flex flex-column gap-2 mt-3" v-if="contactRequested">
                  <a v-if="agent.cell_number" :href="'tel:' + agent.cell_number">
                    Call: {{ agent.cell_number }}
                  </a>
                  <a v-if="agent.email_address" :href="'mailto:' + agent.email_address">
                    Email: {{ agent.email_address }}
                  </a>
                  <a v-if="whatsappLink" :href="whatsappLink" target="_blank" rel="noopener">
                    WhatsApp
                  </a>
                </div>

                <div class="mt-3">
                  <button v-if="!contactRequested" class="btn btn-all w-100" @click="contactRequested = true">
                    Details
                  </button>

                  <a v-else class="btn btn-all w-100" :href="whatsappLink" target="_blank" rel="noopener">
                    Enquire Now
                  </a>
                </div>
              </div>

              <!-- OPTIONAL: Agent 2 (same behavior, still uses your existing flags) -->
              <div class="agent-card mt-4" v-if="agent_2 && agent_2.first_name">
                <div class="section-title">Agent Details</div>
                <div class="section-rule"></div>

                <div class="d-flex gap-3 align-items-center">
                  <div class="agent-photo" v-if="agent_2.agent_photo">
                    <img :src="agent_2.agent_photo" :alt="agent_2.first_name + ' ' + agent_2.last_name">
                  </div>
                  <div>
                    <p class="agent-name">{{ agent_2.first_name }} {{ agent_2.last_name }}</p>
                    <p class="agent-role">{{ agent_2.position || agent_2.role || '' }}</p>
                  </div>
                </div>

                <div class="agent-links d-flex flex-column gap-2 mt-3" v-if="contactRequested_2">
                  <a v-if="agent_2.cell_number" :href="'tel:' + agent_2.cell_number">
                    Call: {{ agent_2.cell_number }}
                  </a>
                  <a v-if="agent_2.email_address" :href="'mailto:' + agent_2.email_address">
                    Email: {{ agent_2.email_address }}
                  </a>
                  <a v-if="whatsappLink_2" :href="whatsappLink_2" target="_blank" rel="noopener">
                    WhatsApp
                  </a>
                </div>

                <div class="mt-3">
                  <button v-if="!contactRequested_2" class="btn btn-all w-100" @click="contactRequested_2 = true">
                    Details
                  </button>

                  <a v-else class="btn btn-all w-100" :href="whatsappLink_2" target="_blank" rel="noopener">
                    Enquire Now
                  </a>
                </div>
              </div>

              <!-- OPTIONAL: Agent 3 -->
              <div class="agent-card mt-4" v-if="agent_3 && agent_3.first_name">
                <div class="section-title">Agent Details</div>
                <div class="section-rule"></div>

                <div class="d-flex gap-3 align-items-center">
                  <div class="agent-photo" v-if="agent_3.agent_photo">
                    <img :src="agent_3.agent_photo" :alt="agent_3.first_name + ' ' + agent_3.last_name">
                  </div>
                  <div>
                    <p class="agent-name">{{ agent_3.first_name }} {{ agent_3.last_name }}</p>
                    <p class="agent-role">{{ agent_3.position || agent_3.role || '' }}</p>
                  </div>
                </div>

                <div class="agent-links d-flex flex-column gap-2 mt-3" v-if="contactRequested_3">
                  <a v-if="agent_3.cell_number" :href="'tel:' + agent_3.cell_number">
                    Call: {{ agent_3.cell_number }}
                  </a>
                  <a v-if="agent_3.email_address" :href="'mailto:' + agent_3.email_address">
                    Email: {{ agent_3.email_address }}
                  </a>
                  <a v-if="whatsappLink_3" :href="whatsappLink_3" target="_blank" rel="noopener">
                    WhatsApp
                  </a>
                </div>

                <div class="mt-3">
                  <button v-if="!contactRequested_3" class="btn btn-all w-100" @click="contactRequested_3 = true">
                    Details
                  </button>

                  <a v-else class="btn btn-all w-100" :href="whatsappLink_3" target="_blank" rel="noopener">
                    Enquire Now
                  </a>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>



      <div style="
        position: fixed;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        z-index: 999;
        padding: 8px 12px;
        background-color: #efefef;
        border-radius: 8px;
      ">
        <div class="d-flex flex-column align-items-start">

          <div class="d-flex align-items-center mb-2">
            <i class="bi bi-whatsapp text-danger me-2" style="font-size:18px;"></i>
            <a v-if="agent.first_name != null" target="_blank" class="text-decoration-none text-danger" :href="whatsappLink" style="font-size:13px;">
              <strong>{{ agent.first_name }}</strong>
            </a>
          </div>

          <div class="d-flex align-items-center">
            <i class="bi bi-whatsapp text-danger me-2" style="font-size:18px;"></i>
            <a v-if="agent_2.first_name != null" target="_blank" class="text-decoration-none text-danger" :href="whatsappLink_2" style="font-size:13px;">
              <strong>{{ agent_2.first_name }}</strong>
            </a>
          </div>

        </div>
      </div>

      <div class="container-fluid pt-5 mt-5" v-if="ogListing[0].status != 'Active'">
        <div class="row pt-4 bg-light">
          <div class="col-md-12 text-center text-uppercase">
            <p v-if="ogListing[0].status == 'Pending'"><strong>This property is under offer</strong></p>
            <p v-if="ogListing[0].status == 'Archived'"><strong>This property is no longer available</strong></p>
          </div>
        </div>
      </div>



      <div class="container-fluid">
        <div class="row mt-5 g-5 switch-bg-lblue" v-if="this.listing !== 'No data found'">
          <div class="col-md-12" v-if="ogListing[0].map_x_position !== null">
            <iframe width="100%" height="450" frameborder="0" style="border:0" :src="'/map.html?lat=' + ogListing[0].map_x_position + '&lng=' + ogListing[0].map_y_position + '&zoom=12'" allowfullscreen></iframe>
          </div>
        </div>
      </div>

      <!-- Mobile Offcanvas Nav -->
      <div class="offcanvas offcanvas-end offcanvas-custom" tabindex="-1" id="mobileNav" aria-labelledby="mobileNavLabel">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title text-white" id="mobileNavLabel">Menu</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>


        <div class="offcanvas-body">
          <div class="list-group list-group-flush">

            <a class="list-group-item list-group-item-action" href="/properties">
              Buy
            </a>

            <a class="list-group-item list-group-item-action" href="/sell">
              Sell
            </a>

            <a class="list-group-item list-group-item-action" href="/developments">
              Developments
            </a>

            <a class="list-group-item list-group-item-action" href="/commercial">
              Commercial
            </a>

          </div>

          <hr />
        </div>
      </div>

    </section>

    <div v-else>
      <div class="container py-5 text-center">
        <h1>Property not available</h1>
        <p>This commercial property is either no longer active or is missing required regulatory information.</p>
        <a href="/commercial" class="btn btn-all">Back to Commercial</a>
      </div>
    </div>

    <Footer />

  </div>
</template>

<script>
import axios from 'axios';
import Menu from '@/components/Menu.vue';
import Footer from '@/components/Footer.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
  components: {
    Menu, Footer, ContactForm
  },
  data() {
    return {
      listing: {
        data: {
          listing: [
            { on_show: false }
          ]
        }
      },
      ogListing: [
        {
          listing_images: []
        }
      ],
      agent: {},
      agent_2: {},
      agent_3: {},
      branch: {},
      loading: true,
      template: 1,
      activeImageIndex: -1,
      isImageExpanded: false,
      isImageClicked: false,
      originalListings: null,
      listings: null,
      contactRequested: false,
      contactRequested_2: false,
      contactRequested_3: false,
      whatsappLink: '',
      whatsappLink_2: '',
      whatsappLink_3: '',
      galleryImages: [],
      galleryView: 'single',
      carouselInstance: null
    };
  },
  mounted() {
    this.fetchListing()

    const modalEl = document.getElementById('galleryModal')
    if (modalEl) {
      modalEl.addEventListener('shown.bs.modal', () => {
        this.showSingle()
        this.$nextTick(() => {
          if (this.carouselInstance) {
            this.carouselInstance.to(0)
          }
        })
      })
    }
  },
  computed: {
    canDisplayProperty() {
      if (!this.ogListing || !this.ogListing[0]) {
        return false
      }

      if (this.ogListing[0].status != 'Active') {
        return false
      }

      if (!this.hasRequiredRegulatoryInformation) {
        return false
      }

      return true
    },
    hasRequiredRegulatoryInformation() {
      if (!this.ogListing || !this.ogListing[0]) {
        return false
      }

      if (!this.hasValue(this.ogListing[0].dldqrcodepath)) {
        return false
      }

      if (!this.hasValue(this.ogListing[0].dldnopath)) {
        return false
      }

      if (!this.hasValue(this.agentLicense)) {
        return false
      }

      return true
    },
    formattedPrice() {
      const price = parseInt(this.ogListing[0].price);
      if (this.ogListing[0].poa == "true") {
        return "POA"
      } else {
        return " " + price.toLocaleString();
      }
    },
    formattedDescription() {
      const rawDescription = this.listing.ai_long_description;
      const sentences = rawDescription.split('. ');
      const paragraphs = [];
      for (let i = 0; i < sentences.length; i += 3) {
        const paragraph = sentences.slice(i, i + 3).join('. ');
        if (!paragraph.endsWith('.')) {
          paragraphs.push(paragraph + '.');
        } else {
          paragraphs.push(paragraph);
        }
      }
      return paragraphs;
    },
    currentUrl() {
      return encodeURIComponent(window.location.href)
    },
    listedAgo() {
      if (!this.ogListing || !this.ogListing[0] || !this.ogListing[0].date_added) {
        return '—'
      }

      const added = new Date(this.ogListing[0].date_added)
      const now = new Date()
      const diff = now.getTime() - added.getTime()
      const days = Math.floor(diff / (1000 * 60 * 60 * 24))

      if (days <= 0) {
        return 'Today'
      }

      if (days == 1) {
        return '1 day ago'
      }

      return days + ' days ago'
    },
    dldQrCode() {
      if (!this.ogListing || !this.ogListing[0]) {
        return ''
      }

      return this.ogListing[0].dldqrcodepath || ''
    },
    dldPermitImage() {
      if (!this.ogListing || !this.ogListing[0]) {
        return ''
      }

      return this.ogListing[0].dldnopath || ''
    },
    brokerLicense() {
      if (this.branch && this.hasValue(this.branch.branch_profile)) {
        return this.branch.branch_profile
      }

      return 'Pending'
    },
    agentLicense() {
      if (this.agent && this.agent.fidelity_fund_number) {
        return this.agent.fidelity_fund_number
      }

      if (this.agent_2 && this.agent_2.fidelity_fund_number) {
        return this.agent_2.fidelity_fund_number
      }

      if (this.agent_3 && this.agent_3.fidelity_fund_number) {
        return this.agent_3.fidelity_fund_number
      }

      return ''
    },
    facebookShareLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.currentUrl}`
    },
    linkedinShareLink() {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${this.currentUrl}`
    },
    pinterestShareLink() {
      return `https://www.pinterest.com/pin/create/button/?url=${this.currentUrl}`;
    },
    twitterShareLink() {
      const text = encodeURIComponent("Luxury property presented by Chas Everitt Luxury Portfolio");
      return `https://twitter.com/intent/tweet?url=${this.currentUrl}&text=${text}`;
    },
  },
  methods: {
    printToPDF() {
      window.print()
    },
    openGalleryFromListing() {
      this.galleryImages =
        this.ogListing &&
          this.ogListing[0] &&
          this.ogListing[0].listing_images
          ? this.ogListing[0].listing_images
          : []

      this.showSingle()

      this.$nextTick(() => {
        const carouselEl = document.getElementById('galleryCarousel')
        if (carouselEl && window.bootstrap) {
          this.carouselInstance = window.bootstrap.Carousel.getOrCreateInstance(carouselEl, {
            interval: false
          })
          this.carouselInstance.to(0)
        }
      })
    },

    showSingle() {
      this.galleryView = 'single'
    },

    showGrid() {
      this.galleryView = 'grid'
    },

    thumbClick(idx) {
      this.showSingle()
      this.$nextTick(() => {
        if (this.carouselInstance) {
          this.carouselInstance.to(idx)
        }
      })
    },




    fetchListing: async function () {
      this.loading = true

      try {
        const response = await axios.post('https://chas-dubai.stratitude-develop.co.za/api/fetch-listing-commercial.php', {
          id: this.$route.params.propertyId
        }, {
          headers: {
            'Accept': 'application/json',
          }
        });

        this.ogListing = response.data.data.listing
        console.log(this.ogListing)
      } catch (error) {
        console.log(error)
      }

      if (this.ogListing && this.ogListing[0]) {
        await this.fetchAgents()
      }

      this.loading = false
    },

    async fetchAgents() {
      if (this.ogListing[0].agent) {
        this.agent = await this.fetchAgent(this.ogListing[0].agent)
      }

      if (this.ogListing[0].agent_2) {
        this.agent_2 = await this.fetchAgent(this.ogListing[0].agent_2)
      }

      if (this.ogListing[0].agent_3) {
        this.agent_3 = await this.fetchAgent(this.ogListing[0].agent_3)
      }

      await this.fetchBranchFromAgents()
      this.buildWhatsappLinks()
    },

    async fetchAgent(agentId) {
      try {
        const agentResponse = await axios.post('https://chas-dubai.stratitude-develop.co.za/api/fetch-agent.php', {
          id: agentId
        }, {
          headers: {
            'Accept': 'application/json',
          }
        })

        if (agentResponse.data && agentResponse.data.data && agentResponse.data.data.agent) {
          if (Array.isArray(agentResponse.data.data.agent)) {
            return agentResponse.data.data.agent[0] || {}
          }

          return agentResponse.data.data.agent
        }
      } catch (error) {
        console.log(error)
      }

      return {}
    },

    async fetchBranchFromAgents() {
      const branchId = this.getFirstBranchIdFromAgents()

      if (!branchId) {
        this.branch = {}
        return
      }

      this.branch = await this.fetchBranch(branchId)
    },

    getFirstBranchIdFromAgents() {
      const agents = [this.agent, this.agent_2, this.agent_3]

      for (let index = 0; index < agents.length; index += 1) {
        const agent = agents[index]

        if (agent && Array.isArray(agent.branches) && agent.branches.length > 0) {
          return agent.branches[0]
        }
      }

      return ''
    },

    async fetchBranch(branchId) {
      try {
        const response = await axios.post('https://chas-dubai.stratitude-develop.co.za/api/fetch-branch.php', {
          id: branchId
        }, {
          headers: {
            'Accept': 'application/json',
          }
        })

        if (response.data && response.data.data && response.data.data.branch) {
          if (Array.isArray(response.data.data.branch)) {
            return response.data.data.branch[0] || {}
          }

          return response.data.data.branch
        }
      } catch (error) {
        console.log(error)
      }

      return {}
    },

    buildWhatsappLinks() {
      this.whatsappLink = this.createWhatsappLink(this.agent)
      this.whatsappLink_2 = this.createWhatsappLink(this.agent_2)
      this.whatsappLink_3 = this.createWhatsappLink(this.agent_3)
    },

    createWhatsappLink(agent) {
      if (!agent || !agent.cell_number) {
        return ''
      }

      const formattedNumber = this.normalisePhoneNumber(agent.cell_number)

      if (!formattedNumber) {
        return ''
      }

      const currentURL = window.location.href
      const message = encodeURIComponent('Hello! I am interested in the property I found on your Portfolio website: ' + currentURL)

      return 'https://wa.me/' + formattedNumber + '?text=' + message
    },

    normalisePhoneNumber(number) {
      if (!number) {
        return ''
      }

      const cleanedNumber = String(number).replace(/\D/g, '')

      if (!cleanedNumber) {
        return ''
      }

      if (cleanedNumber.substring(0, 2) == '27') {
        return cleanedNumber
      }

      if (cleanedNumber.substring(0, 3) == '971') {
        return cleanedNumber
      }

      return '971' + cleanedNumber
    },

    hasValue(value) {
      if (value === null || value === undefined) {
        return false
      }

      if (String(value).trim() == '') {
        return false
      }

      return true
    },

    numberValue(value) {
      const number = parseFloat(value)

      if (isNaN(number)) {
        return 0
      }

      return number
    },

    showNumber(value) {
      return this.numberValue(value) > 0
    },

    formatSize(value, measurementType) {
      const number = this.numberValue(value)

      if (number <= 0) {
        return '—'
      }

      if (measurementType) {
        return number.toLocaleString() + ' ' + measurementType
      }

      return number.toLocaleString() + ' m²'
    },

    formatDate(value) {
      if (!value) {
        return '—'
      }

      const date = new Date(value)

      if (isNaN(date.getTime())) {
        return value
      }

      return date.toLocaleDateString('en-ZA', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },

    expandImage(index) {
      this.activeImageIndex = index
      this.isImageExpanded = true
      this.isImageClicked = true
    }
  }
};
</script>
<style scoped>
.fixed-tags {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 1000;
}

.expanded {
  transform: scale(1.2);
  z-index: 1;
}

.social-links {
  position: unset;
  display: inline;
  float: right;
  margin-right: 20px;
}

.force-height {
  height: 300px;
  object-fit: cover;
}

.carousel-control-next-icon {
  background-color: red;
  border-radius: 25px;
  font-size: 10px;
}

.carousel-control-prev-icon {
  background-color: red;
  border-radius: 25px;
  font-size: 10px;
}

.buy-hero {
  position: relative;
  min-height: 520px;
  /* adjust */
  overflow: hidden;
}

.hero-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-content {
  position: relative;
  z-index: 2;
}

.gallery-modal {
  background: #111;
  color: #fff;
  height: 100vh;
}

.gallery-modal .modal-body {
  overflow-y: auto;
  min-height: 0;
}

.gallery-modal .modal-content {
  height: 100vh;
}
.regulatory-panel {
  background: #f7f7f7;
  border-radius: 18px;
  padding: 32px;
}

.regulatory-title {
  font-size: 26px;
  font-weight: 800;
  margin-bottom: 24px;
  color: #333;
}

.reg-row {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 18px;
  margin-bottom: 18px;
  align-items: center;
  color: #444;
}

.reg-row strong {
  font-size: 16px;
  font-weight: 800;
}

.reg-row span {
  font-size: 16px;
}

.dld-qr {
  width: 190px;
  max-width: 100%;
  height: auto;
}

.dld-label {
  font-size: 20px;
  color: #444;
}

.dld-permit-image {
  max-width: 100%;
  height: auto;
  margin-top: 10px;
}

@media (max-width: 767.98px) {
  .regulatory-panel {
    padding: 22px;
  }

  .reg-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}

</style>